'use strict';

import * as _ from 'lodash';
import moment from 'moment';
import {$, jQuery} from 'jquery';

import routes from './monitoring.routes';

const angular = require('angular');
const uiRouter = require('angular-ui-router');

window.moment = moment;

export class MonitoringComponent {
  constructor($rootScope, $scope, $http, $stateParams, $state, $cookies){
    let refreshTimeout = null;
    const todayRange = () => {
      const start = new Date();
      start.setHours(0, 0, 0, 0);

      const end = new Date();
      end.setHours(23, 59, 59, 999);
      return [moment(start), moment(end)];
    };    

    const yesterdayRange = () => {
      const start = new Date();
      start.setDate(start.getDate() - 1);
      start.setHours(0, 0, 0, 0);

      const end = new Date();
      end.setDate(end.getDate() - 1);      
      end.setHours(23, 59, 59, 999);
      return [moment(start), moment(end)];
    };    

    const lastSevenDaysRange = d => {
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      return [moment().subtract(d, 'days'), moment(end)];
    };  
    
    $scope.$state = $state;
    $scope.selectedType = $stateParams.type ? $stateParams.type : 'app';
    $scope.selectedId = $stateParams.id ? $stateParams.id : null;
    $scope.summary = null;
    $scope.loading = false;
    $scope.$stateParams = $stateParams;

    $scope.dimmension = 'totalNumMessages';

    $scope.startDate = window.localStorage['monitoring-start-date'] ? moment(new Date(window.localStorage['monitoring-start-date'])) : moment().subtract(5, 'days');
    $scope.endDate = window.localStorage['monitoring-end-date'] ? moment(new Date(window.localStorage['monitoring-end-date'])) : moment();

    $scope.goToType = type => {
      $state.go('monitoring-type', { type: type });
    };

    $scope.getUtcString = date => {
      const result = JSON.stringify(new Date(date.toUTCString())).replace(/"/g, '');
      return result;
    };

    $scope.goToAll = (type) => {
      $state.go('monitoring-type', { type });
    }
    
    $scope.options = {    
      clearOnCancel: false,  
      opens: 'left',
      format: 'MMMM D, YYYY',      
      minDate: '01/01/2018',
      maxDate: moment().endOf('day'),
      showWeekNumbers: true,
      timePicker: false,
      timePickerIncrement: 1,
      timePicker12Hour: true,
      cancelButtonClasses: 'hidden',      
      locale: {
        cancelLabel: 'Cancel',
        fromLabel: 'From',
        toLabel: 'To',
        customRangeLabel: 'Custom',        
        daysOfWeek: ['Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'],
            monthNames: ['January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'],
        firstDay: 1
      },      
      alwaysShowCalendars: true,
      ranges: {
        Today: todayRange(),
        Yesterday: yesterdayRange(),
        'Last 7 Days': lastSevenDaysRange(6),
        'Last 30 Days': lastSevenDaysRange(29),
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month')
                  .startOf('month'), moment().subtract(1, 'month')
                  .endOf('month')]
     }
    };

    $scope.goToDimmension = dimmension => {
      $scope.dimmension = dimmension;
      $scope.refreshData();
    };

    $scope.calcPercenatege = (num, total) => {
      if(!total)
        return "0%";
  
      return Math.round((num / total) * 100) + '%';
    };

    $scope.refreshData = () => {
      const doRefresh = () => {
        let reportUri = `/api/monitoring/reports/${$scope.selectedType}/summary?from=${$scope.getUtcString($scope.startDate.toDate())}&to=${$scope.getUtcString($scope.endDate.toDate())}`;
        if($scope.selectedId) {
          reportUri += `&id=${$scope.selectedId}`;
        }
        $http.get(reportUri)
          .then(res => {
             $scope.summary = res.data;
             $scope.title = $scope.selectedId 
              ? ($scope.selectedType === 'app' ? `Application: ${$scope.summary.name}` : `API: ${$scope.summary.name}`)
              : '';             
              let timelineUrl = `/api/monitoring/reports/${$scope.selectedType}/timeline?metric=${$scope.dimmension}&from=${$scope.getUtcString($scope.startDate.toDate())}&to=${$scope.getUtcString($scope.endDate.toDate())}`;
              if($scope.selectedId) {
                timelineUrl += `&id=${$scope.selectedId}`;
              }
              $http.get(timelineUrl)
              .then(timelineRes => { 
                  window.Highcharts.setOptions({global: {useUTC: false}});
                  timelineRes.data.title = { text: $scope.title };
                  window.Highcharts.chart('highcharts-container', timelineRes.data);
                  $scope.loading = false;                  
                });
          });
      };
      window.clearTimeout(refreshTimeout);      
      $scope.loading = true;
      refreshTimeout = window.setTimeout(() => { doRefresh(); }, 200);
    };

    $scope.$on("$destroy", function() {
      window.$('.daterangepicker').remove();
    });
    
    $scope.refreshData();
    $scope.$watch('startDate', () => { 
      window.localStorage['monitoring-start-date'] = $scope.startDate.toString();
      $scope.refreshData(); 
    });
    $scope.$watch('endDate', () => { 
      window.localStorage['monitoring-end-date'] = $scope.endDate.toString();      
      $scope.refreshData(); 
    });
    $scope.$watch('selectedType', () => { $scope.refreshData(); });
  }
}

MonitoringComponent.$inject = ['$rootScope', '$scope', '$http', '$stateParams', '$state', '$cookies'];

export default angular.module('syncplicityLoginApp.monitoring', [uiRouter])
  .config(routes)
  .component('monitoring', {
    template: require('./monitoring.html'),
    controller: MonitoringComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/monitoring/monitoring.component.js